import { render } from "./SquareTag.vue?vue&type=template&id=2a0bc40c&scoped=true"
const script = {}

import "./SquareTag.vue?vue&type=style&index=0&id=2a0bc40c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\git\\git\\chess-com-frontend-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0bc40c"]])

export default __exports__